import classNames from "classnames";
import { CSSProperties } from "react";
import useElementOnScreen from "../../../hooks/useElementOnScreen";
import "./Picture.scss";

type PictureProps = {
	mobileSrc: string;
	alt?: string;
	desktopSrc: string;
	width?: string;
	height?: string;
	className?: string;
	media?: string;
	sizes?: string;
	style?: CSSProperties;
};

const Picture = ({
	mobileSrc,
	alt = "",
	desktopSrc,
	width,
	height,
	className,
	media,
	sizes,
	style,
}: PictureProps) => {
	const [containerRef, isVisible] = useElementOnScreen<Element>();
	const hasFadeInFromDirection = /fade-in--from-[^\s]+/.test(className || "");

	return (
		<picture
			className={classNames("picture fade-in fade-in--from-left", className, {
				"fade-in--from-left": !hasFadeInFromDirection,
				visible: isVisible,
			})}
			style={style}
			ref={containerRef as any}>
			<source
				media={media || "(min-width: 1440px)"}
				srcSet={desktopSrc}
				sizes={sizes}
			/>
			<img src={mobileSrc} alt={alt} width={width} height={height} />
		</picture>
	);
};

export default Picture;
